import { Check } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheckmark = mkIcon(Check);